import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useRatePlan} from "../hooks/useRatePlan.ts";
import {BillablePeriod, RatePlan} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {
        createRecord,
    } = useRatePlan();

    return (
        <FormDrawer
            record={{
                id: '',
                name: '',
                // FNP-802: seeded empty — the unit is now a reference picked from the
                // Billable Units module, not a default enum value. Defaulting to some
                // arbitrary unit would silently price the wrong meter.
                billableUnitId: '',
                billablePeriod: BillablePeriod.MONTH,
                chargeTiers: [],
            } as RatePlan}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
